import React, { useCallback, useState } from 'react';

import { Autoplay, EffectFade } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';

import { PhoneIcon, MailIcon } from './atoms/contactIcons';
import Intro, { shouldPlayIntro, rememberIntroPlayed } from './atoms/intro';

import "swiper/css";
import "swiper/css/effect-fade";

const SLIDES = [
    { image: '/images/top1-min.jpg', alt: 'スタジオの内観' },
    { image: '/images/top2-min.jpg', alt: 'レッスン用バーと大型鏡' },
    { image: '/images/top3-min.jpg', alt: 'リノリウムを敷いたフロア' },
    { image: '/images/top4-min.jpg', alt: 'スタジオの窓側' },
]

const prefersReducedMotion = () =>
    typeof window !== 'undefined' &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches

const Top = () => {
    // オープニング動画は初回訪問時だけ再生する
    const [isIntroVisible, setIsIntroVisible] = useState(shouldPlayIntro)

    const handleIntroFinish = useCallback(() => {
        rememberIntroPlayed()
        setIsIntroVisible(false)
    }, [])

    return (
        <div id='top'>
            {isIntroVisible && <Intro onFinish={handleIntroFinish} />}
            <div className='hero-media'>
                <Swiper
                    modules={[Autoplay, EffectFade]}
                    effect='fade'
                    fadeEffect={{ crossFade: true }}
                    slidesPerView={1}
                    loop
                    autoplay={prefersReducedMotion() ? false : { delay: 5000, disableOnInteraction: false }}
                    speed={1500}
                    allowTouchMove={false}
                >
                    {SLIDES.map((slide) => (
                        <SwiperSlide key={slide.image}>
                            <img src={process.env.PUBLIC_URL + slide.image} alt={slide.alt} />
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>

            <div className='hero-content'>
                <h1 className='hero-title'>Liina Dance Studio</h1>
                <div className='hero-rule'></div>
                {/* 狭い画面で語の途中で折り返さないよう、意味の切れ目で区切る */}
                <p className='hero-text'>
                    <span>高坂駅から徒歩3分</span>
                    <span>大型鏡・リノリウム完備のスタジオ</span>
                </p>
                <div className='hero-actions'>
                    <a className='action-button primary' href='tel:0493-81-6300'>
                        <PhoneIcon />
                        0493-81-6300
                    </a>
                    <a className='action-button secondary' href='mailto:liina.dancestudio@gmail.com'>
                        <MailIcon />
                        メールで問い合わせ
                    </a>
                </div>
            </div>
        </div>
    )
}

export default Top
